/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * clarityrcm.api
 * OpenAPI spec version: 1.0
 */
import type {
  CcofPatientDetails,
  CcofPatientSearchFilterTokenPagedRequest,
  CcofPatientSearchResultTokenPagedResult,
} from "../../../../../lib/api-types/schemas";

import { authenticatedClient } from "../../authenticatedClient";

/**
 * **Actor types:** `clinic`, `internal`

**Practice-scoped:** route `{practiceId}` must match the user's `practiceId` claims

Loads the selected patient for the CCoF view. Returns identification fields, the guarantor (with contact phone for the manual card capture flow), and a card-on-file slot.
 * @summary Retrieves a patient by id, scoped to the active practice.
 */
export type getApiCcofPracticeIdPatientsPatientIdResponse200 = {
  data: CcofPatientDetails;
  status: 200;
};

export type getApiCcofPracticeIdPatientsPatientIdResponse401 = {
  data: void;
  status: 401;
};

export type getApiCcofPracticeIdPatientsPatientIdResponse403 = {
  data: void;
  status: 403;
};

export type getApiCcofPracticeIdPatientsPatientIdResponse404 = {
  data: void;
  status: 404;
};

export type getApiCcofPracticeIdPatientsPatientIdResponseSuccess =
  getApiCcofPracticeIdPatientsPatientIdResponse200 & {
    headers: Headers;
  };
export type getApiCcofPracticeIdPatientsPatientIdResponseError = (
  | getApiCcofPracticeIdPatientsPatientIdResponse401
  | getApiCcofPracticeIdPatientsPatientIdResponse403
  | getApiCcofPracticeIdPatientsPatientIdResponse404
) & {
  headers: Headers;
};

export const getGetApiCcofPracticeIdPatientsPatientIdUrl = (
  practiceId: string,
  patientId: string,
) => {
  return `/api/ccof/${practiceId}/patients/${patientId}`;
};

export const getApiCcofPracticeIdPatientsPatientId = async (
  practiceId: string,
  patientId: string,
  options?: RequestInit,
): Promise<getApiCcofPracticeIdPatientsPatientIdResponseSuccess> => {
  return authenticatedClient<getApiCcofPracticeIdPatientsPatientIdResponseSuccess>(
    getGetApiCcofPracticeIdPatientsPatientIdUrl(practiceId, patientId),
    {
      ...options,
      method: "GET",
    },
  );
};

/**
 * **Actor types:** `clinic`, `internal`

**Practice-scoped:** route `{practiceId}` must match the user's `practiceId` claims
 * @summary Searches for patients within the authorised practice.
Results are strictly scoped to the practice identified by practiceId.
Search criteria are submitted in the request body to prevent PHI from appearing in URLs or server access logs.
 */
export type postApiCcofPracticeIdPatientsSearchResponse200 = {
  data: CcofPatientSearchResultTokenPagedResult;
  status: 200;
};

export type postApiCcofPracticeIdPatientsSearchResponse401 = {
  data: void;
  status: 401;
};

export type postApiCcofPracticeIdPatientsSearchResponse403 = {
  data: void;
  status: 403;
};

export type postApiCcofPracticeIdPatientsSearchResponseSuccess =
  postApiCcofPracticeIdPatientsSearchResponse200 & {
    headers: Headers;
  };
export type postApiCcofPracticeIdPatientsSearchResponseError = (
  | postApiCcofPracticeIdPatientsSearchResponse401
  | postApiCcofPracticeIdPatientsSearchResponse403
) & {
  headers: Headers;
};

export const getPostApiCcofPracticeIdPatientsSearchUrl = (
  practiceId: string,
) => {
  return `/api/ccof/${practiceId}/patients/search`;
};

export const postApiCcofPracticeIdPatientsSearch = async (
  practiceId: string,
  ccofPatientSearchFilterTokenPagedRequest: CcofPatientSearchFilterTokenPagedRequest,
  options?: RequestInit,
): Promise<postApiCcofPracticeIdPatientsSearchResponseSuccess> => {
  return authenticatedClient<postApiCcofPracticeIdPatientsSearchResponseSuccess>(
    getPostApiCcofPracticeIdPatientsSearchUrl(practiceId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(ccofPatientSearchFilterTokenPagedRequest),
    },
  );
};
